import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { EntityService } from '../../shared/services/entity.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-folder-content',
  templateUrl: './folder-content.component.html',
  styleUrls: ['./folder-content.component.scss']
})
export class FolderContentComponent implements OnInit, OnDestroy, AfterViewInit {
  entityId: string | null = null;
  subscriptions: Subscription[] = [];

  constructor(
    protected entityService: EntityService,
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(this.entityService.getEntityId().subscribe(entityId => {
      this.entityId = entityId;
    }));
  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

}
